var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 19,
    viewBox: "0 0 96 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.491 18.789V15.2996H4.30454V10.9513H12.9938V7.56928H4.30454V3.48938H14.1435V0H0V18.789H14.491ZM27.5686 18.789L35.6697 0H31.3652L25.5901 13.4207L19.8953 0H15.2165L23.2908 18.789H27.5686ZM38.166 0H46.6794C48.714 0 50.5077 0.393674 52.0605 1.18102C53.6311 1.95048 54.8447 3.04203 55.7014 4.45567C56.576 5.86932 57.0132 7.5156 57.0132 9.39449C57.0132 11.2734 56.576 12.9197 55.7014 14.3333C54.8447 15.747 53.6311 16.8475 52.0605 17.6348C50.5077 18.4043 48.714 18.789 46.6794 18.789H38.166V0ZM46.4652 15.2191C48.3392 15.2191 49.8295 14.7001 50.9361 13.6623C52.0605 12.6065 52.6227 11.1839 52.6227 9.39449C52.6227 7.60507 52.0605 6.19142 50.9361 5.15355C49.8295 4.09779 48.3392 3.56991 46.4652 3.56991H42.503V15.2191H46.4652ZM74.7942 15.2996V18.789H60.284V0H74.4462V3.48938H64.5942V7.56928H73.295V10.9513H64.5942V15.2996H74.7942ZM87.8891 18.789L96.0009 0H91.6906L85.908 13.4207L80.2056 0H75.5206L83.6056 18.789H87.8891Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.43bad37a04b294915e5d3fa3e166816c.svg";
export { ForwardRef as ReactComponent };